import React from 'react';
import { trackEvent } from '@99designs/tracking';
import Button from '@99designs/frontend-components/components/Button/Button';
import scrollToElement from '../../../shared/lib/scrollToElement';

interface Props {
    id: string;
    name: string;
    categoryKey: string;
    trackEventTitle: string;
    trackEventName: string;
    offset: number;
}
export default function ScrollToSectionButton({
    id,
    name,
    categoryKey,
    trackEventTitle,
    trackEventName,
    offset,
}: Props) {
    return (
        <Button
            variations={['jumbo', 'secondary']}
            onClick={(event) => {
                const section = document.querySelector(id);
                if (section) {
                    event.preventDefault();
                    scrollToElement(section, offset);
                    trackEvent(trackEventTitle, {
                        name: trackEventName,
                        category: categoryKey,
                    });
                }
            }}
        >
            {name}
        </Button>
    );
}
